const getCountriesCode = (name: string) => {
  if (name.toUpperCase().indexOf('ITALY') > -1) {
    return 'it'
  }
  return 'de, at'
}

export default getCountriesCode
